class BarraFreteGratisUpdater {
    constructor() {
        this.init();
    }
    init() {
        window.addEventListener("cart:updated", () => this.updateBarras());
        this.updateBarras();
    }
    async updateBarras() {
        try {
            const response = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const text = await response.text();
            const dom = new DOMParser().parseFromString(text, "text/html");

            // Atualiza os elementos necessários
            this.updateElement(".freteGratis", dom);
            this.updateElement(".freteGratis2", dom);
        } catch (error) {
            console.error("Erro ao atualizar as barras de frete:", error);
        }
    }
    updateElement(selector, dom) {
        const newElement = dom.querySelector(selector);
        const currentElement = document.querySelector(selector);
        if (newElement && currentElement) {
            currentElement.innerHTML = newElement.innerHTML;
        } else {
            console.warn(`Elemento "${selector}" não encontrado no DOM ou no conteúdo retornado.`);
        }
    }
}
document.addEventListener("DOMContentLoaded", () => {
    new BarraFreteGratisUpdater();
});